import type { ShoppingCartDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { StockValidationResultDto } from '../orders/models';

@Injectable({
  providedIn: 'root',
})
export class ShoppingCartService {
  apiName = 'Default';
  

  addItem = (userId: string, wineId: number, quantity: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ShoppingCartDto>({
      method: 'POST',
      url: '/api/app/shopping-cart/item',
      params: { userId, wineId, quantity },
    },
    { apiName: this.apiName,...config });
  

  adjustCartItemsForStock = (userId: string, stockIssues: StockValidationResultDto[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: `/api/app/shopping-cart/adjust-cart-items-for-stock/${userId}`,
      body: stockIssues,
    },
    { apiName: this.apiName,...config });
  

  clearCart = (userId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: `/api/app/shopping-cart/clear-cart/${userId}`,
    },
    { apiName: this.apiName,...config });
  

  getCart = (userId: string, sommelierSlug?: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ShoppingCartDto>({
      method: 'GET',
      url: `/api/app/shopping-cart/cart/${userId}`,
      params: { sommelierSlug },
    },
    { apiName: this.apiName,...config });
  

  getFileByFileAttachmentId = (fileAttachmentId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: `/api/app/shopping-cart/file/${fileAttachmentId}`,
    },
    { apiName: this.apiName,...config });
  

  removeItem = (userId: string, wineId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ShoppingCartDto>({
      method: 'DELETE',
      url: '/api/app/shopping-cart/item',
      params: { userId, wineId },
    },
    { apiName: this.apiName,...config });
  

  removeItemHard = (userId: string, wineId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ShoppingCartDto>({
      method: 'DELETE',
      url: '/api/app/shopping-cart/item-hard',
      params: { userId, wineId },
    },
    { apiName: this.apiName,...config });
  

  updateItemQuantity = (userId: string, wineId: number, quantity: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ShoppingCartDto>({
      method: 'PUT',
      url: '/api/app/shopping-cart/item-quantity',
      params: { userId, wineId, quantity },
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
